import React, { useCallback, useEffect, useRef } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import postSaveAdcd from 'src/services/post/postSaveAdcd'
import Loading from 'src/components/layouts/Loading'
import BGCommon from 'src/assets/img/register/bg-common.png'
import { getParameterName } from 'src/services/get/getParameterName'
import { getUtmParams } from 'src/lib/common'
import { NEW_USER_PATHS } from 'src/routes/newUser'

const REACT_APP_LINE_OFFICIAL_ACCOUNT_LINK = process.env.REACT_APP_LINE_OFFICIAL_ACCOUNT_LINK

const UTM_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign']

export const LiffPage = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const hasRun = useRef(false)
  const redirectTimerRef = useRef(null)

  const adcd = searchParams.get('adcd') || localStorage.getItem('adcd')

  const redirectToLineOAOrHome = useCallback(() => {
    if (REACT_APP_LINE_OFFICIAL_ACCOUNT_LINK) {
      window.location.href = REACT_APP_LINE_OFFICIAL_ACCOUNT_LINK
    } else {
      navigate(NEW_USER_PATHS.LoginPage)
    }
  }, [navigate])

  const SaveUtmParams = useCallback(() => {
    const hasStoredUtm = UTM_PARAMS.some((param) => localStorage.getItem(param))
    if (hasStoredUtm) return
    UTM_PARAMS.forEach((param) => {
      const value = searchParams.get(param)
      if (value) {
        localStorage.setItem(param, value)
      }
    })
  }, [searchParams])

  useEffect(() => {
    if (hasRun.current) return
    hasRun.current = true

    SaveUtmParams()

    if (adcd) {
      getParameterName(adcd)
        .then((data) => {
          if (!data || !data.parameter_name) {
            console.error('getParameterName failed or returned invalid parameter_name')
            redirectToLineOAOrHome()
            return
          }
          const parameterName = data.parameter_name
          const sessionParams = searchParams.get(parameterName) || localStorage.getItem(parameterName)
          localStorage.setItem('adcd', adcd)
          const params = {
            access_token: sessionParams,
            adcd: adcd,
            session_params: sessionParams,
            ...getUtmParams()
          }
          postSaveAdcd(params)
            .then(() => {
              redirectTimerRef.current = setTimeout(() => {
                redirectToLineOAOrHome()
              }, adcd === 'fam_te_01' ? 3000 : 0)
            })
            .catch((e) => {
              console.error('postSaveAdcd error:', e)
              redirectToLineOAOrHome()
            })
        })
        .catch((e) => {
          console.error('getParameterName error:', e)
          redirectToLineOAOrHome()
        })
    } else {
      redirectToLineOAOrHome()
    }

    return () => {
      if (redirectTimerRef.current) {
        clearTimeout(redirectTimerRef.current)
      }
    }
  }, [])

  return (
    <Wrapper>
      <Loading />
    </Wrapper>
  )
}

const Wrapper = styled.div.attrs({
  className: 'sm:w-[400px] w-screen h-screen mx-auto relative bg-center bg-cover bg-no-repeat'
})`
  background-image: url('${BGCommon}');
`
